<main class="container">
    
    <button
        mat-button
        class="back-to-profile"
        routerLink="/profile"
    >
    <mat-icon>arrow_back</mat-icon>
        {{"Back" | translate}}
    </button>

    <section class="profile-container">
        <button mat-button routerLink="/profile" class="close-profile">
            <mat-icon>
                close
            </mat-icon>
        </button>

        <h1 class="header-title">{{"My Youth Worker(s)" | translate}} </h1>

        <div *ngIf="!youthWorkers?.primary && !youthWorkers?.secondary">
            <h2>{{"You have no youth workers assigned to you yet." | translate}}</h2>
        </div>

        <div *ngIf="youthWorkers?.primary || youthWorkers?.secondary">
            <div *ngIf="youthWorkers.primary.statusDescription == 'Active'">
                <app-youth-worker-card 
                    [youthWorkerData]="youthWorkers.primary"
                    [isPrimaryYouthWorker]="true">
                </app-youth-worker-card>
            </div>

            <div *ngIf="youthWorkers.primary.statusId != 3 && youthWorkers.primary.statusId != 2">
                <app-youth-worker-card 
                    [youthWorkerData]="youthWorkers?.secondary"
                    [isPrimaryYouthWorker]="false">
                </app-youth-worker-card>
                <app-youth-worker-card 
                    [youthWorkerData]="youthWorkers.primary"
                    [isPrimaryYouthWorker]="true">
                </app-youth-worker-card>
            </div>
            
        </div>
    </section>

    <ng-content></ng-content>
</main>
